import { gql } from '@apollo/client';
import { ATTACHMENTS_FRAGMENT, ATTACHED_FILES_FRAGMENT } from './query';

export const ANSWER_ATTACHMENTS = gql`
  mutation answerAttachments($input: AnswerAttachmentsInput!) {
    answerAttachments(input: $input) {
      questions {
        id
        status
      }
      profile {
        id
        ...Attachments
        ...AttachedFiles
      }
    }
  }
  ${ATTACHMENTS_FRAGMENT}
  ${ATTACHED_FILES_FRAGMENT}
`;
